module.exports = __webpack_public_path__ + "static/media/remember_02.f69ce490.png";